module.exports = __webpack_public_path__ + "static/img/yiner.ca81e431.png";